import React from "react";

const RefundPolicy = () => {
  return (
    <>
      <div className="refund-policy-container">
        <h1>Reschedule policy</h1>
        <p>
          Rescheduling is permitted only once and must occur within the same
          calendar month as the original playing date.
        </p>
        <h1>Cancellation policy</h1>
        <p>
          {`24 hours prior to slot time the amount paid can be used as credit towards another booking .`}
        </p>
      </div>
      <div className="footer"></div>
    </>
  );
};

export default RefundPolicy;
